<template>
  <div class="space-y-8">
    <div>
      <ActivityLogList ref="activityLogList" :contact-id="contactId" />
    </div>
  </div>
</template>

<script>
import ActivityLogList from './ActivityLogList.vue';

export default {
  components: {
    ActivityLogList,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
};
</script>
